import { Image, StatusBadge } from '@domain-group/suit-theme'

import type { ImageModel } from '@models/types'

import placeholderImageUrl from '../../assets/default_campaign_image_400x400.png'

type TileProps = {
  exportSizeErrorImageIds: number[],
  image: ImageModel,
}

const Tile = (props: TileProps) => {
  const {
    exportSizeErrorImageIds,
    image: { id, square_url },
  } = props

  const hasExportSizeError = exportSizeErrorImageIds.includes(id)

  return (
    <Image
      borderRadius="5px"
      boxProps={{
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: 'medium',
        minHeight: 100,
      }}
      placeholderUrl={placeholderImageUrl}
      url={square_url}
      width="100%"
    >
      {hasExportSizeError && (
        <StatusBadge
          boxProps={{
            width: 'auto',
          }}
          color="orange"
          text="Error"
        />
      )}
    </Image>
  )
}

export default Tile
